import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/login')({
  head: () => ({
    meta: [
      { title: 'Admin Login | Calvarius' },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
});
